/* Delilah offer bar: Buy 2 get 1 FREE, then (once unlocked) Buy 3 get 2 FREE. Max 2 free per order.
   Works for every [data-delilah-offer-bar] on the page (site bar + cart drawer).
   Reads the live cart (/cart.js) so the saving shown is exactly what Shopify applied. */
(function () {
  if (window.__dlOffer) return; window.__dlOffer = true;

  var COPY = [
    'Buy 2 get 1 FREE',
    'Add 1 more to unlock a FREE item',
    "You've unlocked a FREE item - add now",
    'Add 1 more item and get another item FREE',
    "You've unlocked a 2nd FREE item - add now",
    "Congrats! You've unlocked 2 FREE items"
  ];
  var GIFT = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M5 10h14v10H5zM3.5 7h17v3h-17zM12 7v13"/><path d="M12 7c-1.5-3-5-3.2-5-1.2S10 7 12 7zm0 0c1.5-3 5-3.2 5-1.2S14 7 12 7z"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" width="12" height="12" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>';
  var SPARK = '<svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true"><path d="M12 2l2.2 6.8L21 11l-6.8 2.2L12 20l-2.2-6.8L3 11l6.8-2.2z"/></svg>';
  // Stage 0: pieces 1-3 (Buy 2 get 1). Stage 1: pieces 4-5 (Buy 3 get 2, revealed once stage 0 is done). Stage 2: maxed.
  var STAGES = [{ from: 0, to: 3, pips: [1, 2, 3], gift: 3 }, { from: 3, to: 5, pips: [4, 5], gift: 5 }];
  var lastTier = -1, lastCart = null;

  function eligibleUnits(cart) {
    // Mirrors the discount: All Jewellery (variant price over £7 and under £35). No gift cards, add-ons or spare backs (spare backs have their own 3 for 2 deal).
    return cart.items.reduce(function (n, i) {
      var p = i.original_price;
      var spare = i.handle === 'flat-back-backs-gold' || i.handle === 'flat-back-backs-silver';
      var ok = !spare && (!i.gift_card && (i.product_type || '').toLowerCase() !== 'add-on' && p > 700 && p < 3500);
      return ok ? n + i.quantity : n;
    }, 0);
  }

  function drawShip(bar, ship) {
    var el = bar.querySelector('[data-offer-ship]');
    if (!el) return;
    var was = !el.hidden;
    el.hidden = !ship;
    if (ship && !was && bar.hasAttribute('data-ready')) { el.classList.remove('is-pop'); void el.offsetWidth; el.classList.add('is-pop'); }
  }

  function draw(bar, n, saved, cur) {
    var stage = n >= 5 ? 2 : n >= 3 ? 1 : 0;
    var msg = bar.querySelector('[data-offer-msg]');
    var save = bar.querySelector('[data-offer-save]');
    var fill = bar.querySelector('[data-offer-fill]');
    var pipsEl = bar.querySelector('[data-offer-pips]');
    var doneEl = bar.querySelector('[data-offer-done]');
    var levelEl = bar.querySelector('[data-offer-level]');
    var meterEl = bar.querySelector('.dl-offer__meter');
    var maxEl = bar.querySelector('[data-offer-max]');
    if (!msg || !pipsEl) return;
    var prev = Number(bar.getAttribute('data-stage'));
    if (prev !== stage) {
      if (stage < 2) {
        var st = STAGES[stage];
        pipsEl.innerHTML = st.pips.map(function (k) {
          var left = ((k - st.from) / (st.to - st.from)) * 100;
          return '<span class="dl-offer__pip' + (k === st.gift ? ' is-gift' : '') + '" data-pip="' + k + '" style="left:' + left + '%">' + (k === st.gift ? GIFT : k) + '</span>';
        }).join('');
      } else pipsEl.innerHTML = '';
      bar.classList.toggle('is-maxed', stage === 2);
      bar.classList.toggle('is-bonus', stage >= 1);
      meterEl.hidden = stage === 2;
      if (maxEl) {
        maxEl.hidden = stage !== 2;
        maxEl.innerHTML = '<span class="dl-offer__burst" aria-hidden="true"><i></i><i></i><i></i><i></i><i></i><i></i></span>' +
          '<span class="dl-offer__pill">' + SPARK + '<small class="dl-offer__congrats">Congrats!</small><b>2 FREE</b><small>items unlocked</small>' + SPARK + '</span>';
      }
      doneEl.hidden = stage !== 1;
      doneEl.innerHTML = TICK + ' 1 FREE';
      if (levelEl) levelEl.hidden = stage !== 1;
      if (!isNaN(prev) && bar.hasAttribute('data-ready')) { bar.classList.remove('is-new-stage'); void bar.offsetWidth; bar.classList.add('is-new-stage'); }
      bar.setAttribute('data-stage', stage);
    }
    msg.textContent = COPY[Math.min(n, 5)];
    var pct = stage === 2 ? 100 : ((n - STAGES[stage].from) / (STAGES[stage].to - STAGES[stage].from)) * 100;
    fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
    pipsEl.querySelectorAll('[data-pip]').forEach(function (p) { p.classList.toggle('is-done', n >= Number(p.getAttribute('data-pip'))); });
    if (save) { save.textContent = saved > 0 ? "You're saving " + cur + saved.toFixed(2) : ''; save.hidden = !(saved > 0); }
    // Site bar at 3-4 items: split into "Free item redeemed" | "Bonus offer activated".
    var split = bar.querySelector('[data-offer-split]');
    if (split) {
      var splitOn = stage === 1, wasSplit = bar.classList.contains('is-split');
      bar.classList.toggle('is-split', splitOn);
      if (splitOn) {
        var four = n >= 4;
        split.querySelector('[data-split-fill]').style.width = (four ? 100 : 6) + '%';
        split.querySelector('[data-split-pip]').classList.toggle('is-on', four);
        split.querySelector('[data-split-gift]').classList.toggle('is-hot', four);
        split.querySelector('[data-split-msg]').innerHTML = four ? '<b>Your next item is FREE!</b>' : 'Add <b>1 item</b> to get <b>1 FREE item</b>';
        var ss = split.querySelector('[data-split-save]');
        if (ss) { ss.textContent = saved > 0 ? "You're saving " + cur + saved.toFixed(2) : ''; ss.hidden = !(saved > 0); }
        if (!wasSplit && bar.hasAttribute('data-ready')) { split.classList.remove('is-in'); void split.offsetWidth; split.classList.add('is-in'); }
      }
    }
    bar.setAttribute('data-count', n);
    bar.setAttribute('data-ready', '');
  }

  function render(cart) {
    lastCart = cart;
    var n = eligibleUnits(cart);
    var saved = (cart.total_discount || 0) / 100;
    document.querySelectorAll('[data-delilah-offer-bar]').forEach(function (bar) {
      drawShip(bar, (cart.total_price || 0) >= 5000);
      draw(bar, n, saved, bar.getAttribute('data-currency') || '£');
    });
    drawPdp(n);
    document.dispatchEvent(new CustomEvent('dl:cart', { detail: { cart: cart } }));
    var tier = n >= 5 ? 2 : n >= 3 ? 1 : 0;
    if (lastTier !== -1 && tier > lastTier) celebrate();
    lastTier = tier;
  }

  // Product-page offer card copy by basket count.
  var PDP = [
    ['Buy 2 get 1 FREE', 'Add 2 items and get the 3rd FREE. Mix and match any styles, kids or grown-up.'],
    ['Add one more item to unlock a FREE item', ''],
    ['FREE item unlocked! Add any item now (cheapest will be free)', ''],
    ['Bonus offer: Add 1 more item to get another item for FREE', ''],
    ['2nd FREE item unlocked! Add any item now', ''],
    ['2 FREE items unlocked!', 'Congrats, your 2 cheapest items are FREE!']
  ];
  function drawPdp(n) {
    document.querySelectorAll('[data-dl-pdp-offer]').forEach(function (card) {
      var prev = Number(card.getAttribute('data-count'));
      var c = PDP[Math.min(n, 5)];
      card.querySelector('[data-dl-pdp-h]').textContent = c[0];
      var sub = card.querySelector('[data-dl-pdp-s]');
      sub.textContent = c[1]; sub.hidden = !c[1];
      card.classList.toggle('is-unlocked', n === 2);
      card.classList.toggle('is-bonus', n >= 3);
      var badge = card.querySelector('[data-dl-pdp-badge]');
      if (badge) badge.textContent = n >= 3 ? 'Bonus offer activated' : 'Offer activated';
      var max = n >= 3 ? 5 : 3, dots = '';
      for (var k = 1; k <= max; k++) dots += '<b class="' + (n >= k ? 'on' : '') + (k === 3 || k === 5 ? ' gift' : '') + '"></b>';
      card.querySelector('[data-dl-pdp-dots]').innerHTML = dots;
      if (prev !== n) { card.classList.remove('is-bump'); void card.offsetWidth; card.classList.add('is-bump'); }
      card.setAttribute('data-count', n);
    });
  }

  function celebrate() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-delilah-offer-bar]').forEach(function (bar) {
      bar.classList.remove('is-celebrating'); void bar.offsetWidth; bar.classList.add('is-celebrating');
    });
  }

  function refresh() {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); }).then(render).catch(function () {});
  }

  // Refresh after any cart change, whatever the theme or app uses to make it.
  var CART = /\/cart\/(add|change|update|clear)/;
  var _fetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    return _fetch.apply(this, arguments).then(function (res) { if (CART.test(url)) setTimeout(refresh, 60); return res; });
  };
  var _open = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, url) {
    if (CART.test(url)) this.addEventListener('load', function () { setTimeout(refresh, 60); });
    return _open.apply(this, arguments);
  };
  ['cart:updated', 'cart:refresh', 'cart-drawer:open'].forEach(function (e) { document.addEventListener(e, refresh); });

  // The cart drawer re-renders its markup after changes: redraw any new, un-drawn bars.
  new MutationObserver(function () {
    if (!lastCart) return;
    var fresh = document.querySelectorAll('[data-delilah-offer-bar]:not([data-ready])');
    if (fresh.length) render(lastCart);
  }).observe(document.documentElement, { childList: true, subtree: true });

  var siteBar = document.querySelector('.dl-offer--bar');

  // Tapping the "2 FREE items unlocked" pill (or the "1 FREE" chip) in the site bar opens the side cart.
  document.addEventListener('click', function (e) {
    var hit = e.target.closest && e.target.closest('.dl-offer--bar .dl-offer__pill, .dl-offer--bar .dl-offer__done, .dl-offer--bar .dl-split');
    if (!hit) return;
    e.preventDefault();
    var btn = document.querySelector('a.cart-drawer-button[aria-controls="CartDrawer"]') || document.querySelector('.cart-drawer-button');
    if (btn) btn.click(); else window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
  });

  // Desktop/tablet: keep the site bar flush under the theme's sticky header. The header shrinks
  // (and can slide away) as you scroll, so re-measure on scroll, resize and whenever it changes size.
  var lastTop = -1, topTick = false;
  function setTop() {
    topTick = false;
    var top = 0;
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) {
      if (siteBar && el.contains(siteBar)) return;
      var pos = getComputedStyle(el).position;
      if (pos !== 'sticky' && pos !== 'fixed') return;
      var r = el.getBoundingClientRect();
      top = Math.max(top, Math.max(0, Math.min(r.height, r.bottom)));
    });
    top = Math.round(top);
    if (top !== lastTop) { document.documentElement.style.setProperty('--dl-offer-top', top + 'px'); lastTop = top; }
  }
  function queueTop() { if (!topTick) { topTick = true; requestAnimationFrame(setTop); } }
  setTop();
  window.addEventListener('resize', queueTop); window.addEventListener('load', setTop);
  window.addEventListener('scroll', queueTop, { passive: true });
  if (window.ResizeObserver) {
    var ro = new ResizeObserver(queueTop);
    document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) { ro.observe(el); });
  }
  // Header transitions (shrink/slide) take a moment; catch the end state too.
  document.addEventListener('transitionend', function (e) { if (e.target.closest && e.target.closest('.shopify-section-group-header-group')) queueTop(); }, true);

  // Mobile: sit just above the theme's slide-in bottom dock when it is showing.
  var dock = null, ticking = false;
  function setBottom() {
    ticking = false;
    if (!siteBar) return;
    dock = dock || document.querySelector('.mobile-dock');
    if (!dock || window.innerWidth > 749) { siteBar.style.bottom = ''; return; }
    var r = dock.getBoundingClientRect();
    var off = Math.max(0, Math.round(window.innerHeight - r.top));
    siteBar.style.bottom = off ? off + 'px' : '';
  }
  function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(setBottom); } setTimeout(setBottom, 380); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  setBottom();

  refresh();
})();
